import React from 'react';
import styled from 'styled-components/macro';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import LabelLight from '../../typography/LabelLight';
import { Link } from 'react-router-dom';

type CrumbObj = {
  label: string;
  to?: string;
};

interface BreadcrumbProps {
  crumbs: CrumbObj[];
}

const Container = styled.div`
  display: flex;
  align-items: flex-end;
  height: 32px;
  padding-left: 16px;

  a {
    text-decoration: none;
    color: inherit;
    :hover {
      text-decoration: underline;
      color: ${(props) => props.theme.colors.brand01};
    }
  }
`;

const CrumbContainer = styled(LabelLight)`
  display: flex;
  align-items: center;
  font-size: 14px;

  &:first-child .breadcrumb-chevron {
    display: none;
  }
`;

const Crumb = (props: { children: React.ReactNode }) => (
  <CrumbContainer>
    <ChevronRightIcon fontSize="inherit" className="breadcrumb-chevron" />
    {props.children}
  </CrumbContainer>
);

const Breadcrumb = (props: BreadcrumbProps) => {
  return (
    <Container>
      {/* <LabelLight>
        <Link to="/">Dashboard</Link>
      </LabelLight> */}
      {props.crumbs.map((crumbObj, idx) => (
        <Crumb key={idx}>
          {!!crumbObj.to ? (
            <Link to={crumbObj.to}>{crumbObj.label}</Link>
          ) : (
            crumbObj.label
          )}
        </Crumb>
      ))}
    </Container>
  );
};

export default Breadcrumb;
